import { SignalsPage } from '@/pages/signals'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(protected)/workspaces/$workspaceId/pulse/')({
  component: SignalsPage,
})
